import {
  getGetAddressFormatByCarrierAndCountryQueryKey,
  useGetAddressFormatByCarrierAndCountry,
} from '../generated/index.js'
import { AddressFormat, Carrier } from '../model/index.js'

export const useAddressFormat = (carrier: Carrier, country: string): AddressFormat | undefined => {
  const { data: addressFormat } = useGetAddressFormatByCarrierAndCountry(carrier, country, {
    query: {
      queryKey: getGetAddressFormatByCarrierAndCountryQueryKey(carrier, country),
      staleTime: 10 * 60 * 1000,
    },
  })

  return addressFormat as AddressFormat | undefined
}
